export const en = {
    recommended: 'Recommended',
};
